import Popper from 'popper.js';
import jQuery from 'jquery';
import axios from 'axios';
import moment from 'moment';

window.Popper = Popper;
window.$ = window.jQuery = jQuery;
window.moment = moment;

Promise.all([
  import('bootstrap-select'),
  import('jasny-bootstrap'),
  import('arrive'),
  import('./vendors/material-dashboard/core/bootstrap-material-design.min.js'),
  import('./vendors/material-dashboard/plugins/perfect-scrollbar.jquery.min.js'),
  import('./vendors/material-dashboard/plugins/jquery.validate.min.js'),
  import('./vendors/material-dashboard/plugins/jquery.bootstrap-wizard.js'),
  import('./vendors/material-dashboard/plugins/bootstrap-datetimepicker.min.js'),
  import('./vendors/material-dashboard/plugins/bootstrap-notify.js'),
  import('./vendors/material-dashboard/material-dashboard.js'),
]);

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end.
 */
const token = document.head.querySelector('meta[name="csrf-token"]');
window.axios = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': token.content,
  },
});
